import { NOTIFICATIONS_GETTERS } from "./getters-enum";

export default {
    [NOTIFICATIONS_GETTERS.GET_NOTIFICATIONS]: state => state.notifications,
    [NOTIFICATIONS_GETTERS.GET_UNREAD_COUNT]: state => state.notifications.filter(n => !n.read).length
};